import React, { Component, createRef } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { isEmpty, map, reject, size } from "lodash";
import BreadcrumbClient from "../../components/Common/BreadcrumbClient"
import { withTranslation } from "react-i18next"
//import Lead from "./Lead";
import ClientLink from "./client-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Calender from "../Activities/calander"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios"
import DeleteModal from "../../components/Common/DeleteModal";
import { addClientAppointment, getClientDetail, getClientAppointment, deleteClientAppointment, updateClientAppointment } from "../../store/clients/actions"
import Moment from 'react-moment';
import Switch from "react-switch"
import ClientSidebar from "components/VerticalLayout/ClientSidebar";
import RsAdNew from "components/buttons/Adnew";
import { Calendar } from 'primereact/calendar';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import moment from "moment-timezone";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,

} from "reactstrap"
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import SaveButton from "components/buttons/save";
import UpdateButton from "components/buttons/updateBtn";
import RsLink from "components/buttons/rsLink";
import ClientActivityBreadcrumbs from "components/Common/ClientActivityBreadcrumb";
import ClientActivityMenu from "./menu/client-activity-menu";
import TimePicker from "components/dropdowns/Timepicker";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { API_URL } from "helpers/app_url";
import SafeField from "helpers/SafeField";
import { hasPermission } from "helpers/checkPermission";
class ClientApp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      appTypes: [],
      appPriories: [],
      appLocTypes: [],
      appointment: '',
      checked: true,
      expandedRows:null

    }
    this.calendarRef = createRef();
    this.handleSwitch = this.handleSwitch.bind(this);
    this.handelValidAppointment = this.handelValidAppointment.bind(this)
    this.onClickDelete = this.onClickDelete.bind(this);
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.openCalender = this.openCalender.bind(this);

  }
  postActivity = async () => {
    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const payload = {
        activityTypeId: [0],
        activityFromDate:  moment().startOf("month").format("YYYY-MM-DD"),
        activityToDate: moment().add(6, "months").endOf("month").format("YYYY-MM-DD"),
        //refId: parseInt(this.props.match.params.id),
        //refTypeId:2,
        agentId: parseInt(localStorage.getItem('userId'))
      };
  
      const response = await axios.post(
        `${API_URL}Activity/allfilteredactivities`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        }
      );
  
      //
      const rawEvents = response.data || [];
      const events = rawEvents.map(event => {
  
      const start = moment(
        `${event.activityStartDate.split("T")[0]} ${event.startTime}`,
        "YYYY-MM-DD hh:mm A"
      ).format("YYYY-MM-DDTHH:mm:ss");
  
        const end = moment(
          `${event.activityStartDate.split("T")[0]} ${event.endTime}`,
          "YYYY-MM-DD hh:mm A"
        ).format("YYYY-MM-DDTHH:mm:ss");
    const eventStartDate = new Date(start); 
     const now = new Date(); 
          return {
            id: event.activityActivityId,
            title: event.displayTitle,
            start,
            end,
            className: eventStartDate < now ? 'bg-danger text-white' : 'bg-success text-white',
            extendedProps: {
              description: event.activityNotes,
              agentId: event.agentId,
              contactName: event.contactName,
              contactPhone: event.contactPhone,
              contactEmail: event.contactEmail,
              location: event.activityLocation,
            }
          };
        });
    
          this.setState({ resultArray: events,  isLoading: false, });
    } catch (error) {
      console.error("Error posting activity:", error);
    }
  };
  handleSwitch(checked) {
    this.setState({ checked });
  }

  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  toggleCal() {
    this.setState(prevState => ({
      isCal: !prevState.isCal
    }));
  }
  onClickDelete = (appointment) => {
    this.setState({ appointment: appointment });
    this.setState({ deleteModal: true });
  };
  handleDeleteAppointment = () => {
    const { onDeleteAppointment } = this.props;
    const { appointment } = this.state;

    if (appointment.id !== undefined) {
      onDeleteAppointment(appointment);
      this.setState({ deleteModal: false });
      this.toggle();
    }
  };
  handelValidAppointment(value) {
    //
    this.props.addClientAppointment(value, this.props.history);

  }
  componentDidMount() {
    const { match: { params }, onGetClientDetail, onGetClientAppointment } = this.props;
    onGetClientDetail(params.clientId);
    onGetClientAppointment(localStorage.getItem('userId'), params.id)
    this.postActivity();
    
    const offcanvas = document.getElementById("myOffcanvas");

    if (offcanvas) {
      offcanvas.addEventListener("shown.bs.offcanvas", this.handleOffcanvasShown);
    }

  }
    componentWillUnmount() {
    const offcanvas = document.getElementById("myOffcanvas");

    if (offcanvas) {
      offcanvas.removeEventListener("shown.bs.offcanvas", this.handleOffcanvasShown);
    }
  }
  handleOffcanvasShown = () => {
    const calendarApi = this.calendarRef.current?.getApi();
    if (calendarApi) {
      calendarApi.render();
    }
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { appointments } = this.props;
    if (!isEmpty(appointments) && size(prevProps.appointments) !== size(appointments)) {
      this.setState({ appointments: {}, isEdit: false });
    }
  }
  toggleRightCanvas() {
    this.setState({ appointment: "", isEdit: false, isRight: !this.state.isRight });
    this.toggle();
  }
  toggleRightCanvas = arg => {
    const appointment = arg;

    this.setState({
      appointment: {

        id: appointment.id,
        appointmentId: appointment.appointmentId,
        appointmentTitle: appointment.appointmentTitle,
        contactName: appointment.contactName,
        contactPhone: appointment.contactPhone,
        contactEmail: appointment.contactEmail,
        appointmentStartDate: appointment.appointmentStartDate,
        startTime: appointment.startTime,
        endTime: appointment.endTime,
        appointmentType: appointment.appointmentType,
        appointmentStatus: appointment.appointmentStatus,
        appointmentPriority: appointment.appointmentPriority,
        appointmentReminder: appointment.appointmentReminder,
        clientId: appointment.clientId,
        appointmentDescription: appointment.appointmentDescription,
        appointmentLocationType: appointment.appointmentLocationType,
        appointmentLocation: appointment.appointmentLocation,
        locationLatitude: appointment.locationLatitude,
        locationLongitude: appointment.locationLongitude,
        isRepeat: appointment.isRepeat,
        repeatEveryType: appointment.repeatEveryType,
        repeatStep: appointment.repeatStep,
        repeatEndDate: appointment.repeatEndDate,
        agentId: appointment.agentId,
        isActive: appointment.isActive,
        agentNotes: appointment.agentNotes,
        addedBy: appointment.addedBy
      },
      isEdit: true,
    });
    this.toggle();
  };
  handleChange = arg => {
    const appointment = arg;
    const { onUpdateStatus } = this.props;
    const updateReg = {
      id: appointment.id,
      appointmentId: appointment.appointmentId,
      rejected: (appointment.rejected == true) ? false : true,
      appointmentTitle: appointment.appointmentTitle,
      contactName: appointment.contactName,
      contactPhone: appointment.contactPhone,
      contactEmail: appointment.contactEmail,
      appointmentStartDate: appointment.appointmentStartDate,
      startTime: appointment.startTime,
      endTime: appointment.endTime,
      appointmentType: appointment.appointmentType,
      appointmentStatus: appointment.appointmentStatus,
      appointmentPriority: appointment.appointmentPriority,
      appointmentReminder: appointment.appointmentReminder,
      clientId: appointment.clientId,
      appointmentDescription: appointment.appointmentDescription,
      appointmentLocationType: appointment.appointmentLocationType,
      appointmentLocation: appointment.appointmentLocation,
      locationLatitude: appointment.locationLatitude,
      locationLongitude: appointment.locationLongitude,
      isRepeat: appointment.isRepeat,
      repeatEveryType: appointment.repeatEveryType,
      repeatStep: appointment.repeatStep,
      repeatEndDate: appointment.repeatEndDate,
      agentId: appointment.agentId,
      isActive: appointment.isActive,
      contactNotes: appointment.contactNotes,
      addedBy: appointment.addedBy,
      rejected: appointment.rejected,
    }

    onUpdateStatus(updateReg);
  };
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        setFieldValue('appointmentLocation', place.formatted_address);
        setFieldValue('appointmentLatitude', latitude);
        setFieldValue('appointmentLongitude', longitude);
      })
      .catch(error => console.error('Error', error));
  };
  openCalender() {
    this.setState({  isCal: !this.state.isCal });
    //this.toggleCal();
  }
    // fetchEvents = async (startDate, endDate) => {
    //   try {
    //     const obj = JSON.parse(localStorage.getItem("authUser"));
    //     const token = obj?.resultData?.bearerToken;
  
    //     const response = await axios.get(
    //       `${API_URL}Google/GetGoogleEventsFromLocalFarDateRange?code=32B46870-DC67-4FD0-84E5-ECD7B5673691&startDate=${startDate}&endDate=${endDate}`,
    //       {
    //         headers: {
    //           "Content-Type": "application/json",
    //           Authorization: `Bearer ${token}`,
    //         },
    //       }
    //     );
  
    //     const rawEvents = response.data;
  
    //     const events = rawEvents.map(event => ({
    //       id: event.id,
    //       title: event.summary,
    //       start: event.startTime,
    //       end: event.endTime,
    //       url: event.htmlLink,
    //       extendedProps: {
    //         description: event.description,
    //         agentId: event.agentId,
    //         calendarId: event.calendarId,
    //         calendarDetailId: event.calendarDetailId,
    //         eventPageType: event.eventPageType,
    //         eventPageId: event.eventPageId,
    //       },
    //     }));
  
    //     this.setState({ events });
    //   } catch (error) {
    //     console.error("Error fetching events:", error);
    //   }
    // };

// postActivity = async () => {
//   try {
//     const obj = JSON.parse(localStorage.getItem("authUser"));
//     const token = obj?.resultData?.bearerToken;
//     const payload = {
//       activityTypeId: [0],
//       activityFromDate:  moment().startOf("month").format("YYYY-MM-DD"),
//       activityToDate: moment().add(3, "months").endOf("month").format("YYYY-MM-DD"),
//       refId: parseInt(this.props.match.params.id),
//       refTypeId:2,
//       agentId: parseInt(localStorage.getItem('userId'))
//     };

//     const response = await axios.post(
//       `${API_URL}Activity/userfilteredactivitiesbytype`,
//       payload,
//       {
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`
//         }
//       }
//     );

//     
//     const rawEvents = response.data || [];
//     const events = rawEvents.map(event => {

//     const start = moment(
//       `${event.activityStartDate.split("T")[0]} ${event.startTime}`,
//       "YYYY-MM-DD hh:mm A"
//     ).format("YYYY-MM-DDTHH:mm:ss");

//       const end = moment(
//         `${event.activityStartDate.split("T")[0]} ${event.endTime}`,
//         "YYYY-MM-DD hh:mm A"
//       ).format("YYYY-MM-DDTHH:mm:ss");

//         return {
//           id: event.activityActivityId,
//           title: event.displayTitle,
//           start,
//           end,
//           extendedProps: {
//             description: event.activityNotes,
//             agentId: event.agentId,
//             contactName: event.contactName,
//             contactPhone: event.contactPhone,
//             contactEmail: event.contactEmail,
//             location: event.activityLocation,
//           }
//         };
//       });
  
//         this.setState({ events });
//   } catch (error) {
//     console.error("Error posting activity:", error);
//   }
// };
  render() {
    const { clietDetail, appointments, onUpdateClientAppointment, loading, userdetail, isResponsive } = this.props;

    const { isEdit, deleteModal, events, resultArray } = this.state;
    const appointment = this.state.appointment;
    const { checked } = this.state;

    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);

    //
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteAppointment}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="">
                <Row className="project-header">
                  <Col sm="8">
                    <ClientActivityBreadcrumbs
                      title={this.props.t("Clients")}
                      breadcrumbItem={this.props.t("Appointment")}
                    />
                  </Col>
                 <Col sm="4">
                    <div className={`d-flex justify-content-between align-items-center ${isResponsive ? '' : 'pt-2 mt-2'}`}>
                      <h2 className="mb-0 mt-0">
                        {clietDetail.firstName} {clietDetail.lastName}
                      </h2>
                      {!isResponsive &&(
                         <RsAdNew 
                            to="#" 
                            className="btn btn-light btn-md" 
                            iconClass="dripicons-download"
                            onClick={ this.openCalender}
                          >
                            Go to Calendar
                          </RsAdNew>
                      )}
                    
                    </div>
                  </Col>
                </Row>

                <ClientActivityMenu userdetail={userdetail} isResponsive={isResponsive} />



                <Row>
                  {/* <Col xl="3">
              <ClientLink id={this.props.match.params.id} clientId={this.props.match.params.clientId} />
              </Col> */}

                  <Col xl="12">
                    <Card className="border-full">
                      <CardBody>
                        <div className="mt-0 card-title pheading">New Appointment</div>
                        <Formik
                          enableReinitialize={true}
                          initialValues={{
                            appointmentTitle: (this.state && this.state.appointmentTitle) || "",
                            appointmentStartDate: (this.state && this.state.appointmentStartDate) || "",
                            startTime: (this.state && this.state.startTime) || "",
                            endTime: (this.state && this.state.endTime) || "",
                            contactName: clietDetail.firstName + " " + clietDetail.lastName,
                            contactPhone: clietDetail?.primaryContact?.cContact?.mobile,
                            contactEmail: clietDetail?.primaryContact?.cContact?.email,
                            clientId: this.props.match.params.id,
                            agentId: localStorage.getItem('userId'),
                            addedBy: 'agent',
                            appointmentLocationType: 3


                          }}


                          validationSchema={Yup.object().shape({

                            appointmentTitle: Yup.string().max(150, "150 Characters are allowed").required("Please Enter Meeting Agenda"),
                            appointmentStartDate: Yup.string().required("This is Required"),
                            startTime: Yup.string().required("This is Required"),
                            endTime: Yup.string().required("This is Required"),
                          })}



                          onSubmit={(values, { resetForm }) => {
                            const formattedValues = {
                              ...values,
                              appointmentStartDate: moment(values.appointmentStartDate).format('YYYY-MM-DD'),

                            };
                            this.props.addClientAppointment(formattedValues);
                            resetForm();

                          }}
                        >
                          {({ errors, touched, values, handleChange, handelBlur, setFieldValue, setFieldTouched }) => (
                            <Form
                              className="needs-validation"
                            >
                              <Row>
                                <Col md="6">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="appointmentTitle">
                                      {this.props.t("Agenda*")}
                                    </Label>
                                    <input
                                      name="appointmentTitle"
                                      type="text"
                                      value={values.appointmentTitle}
                                      onChange={handleChange}
                                      className={
                                        "form-control" +
                                        (errors.appointmentTitle && touched.appointmentTitle
                                          ? " is-invalid"
                                          : "")
                                      }
                                      id="appAjenda"
                                    />
                                    <ErrorMessage
                                      name="appointmentTitle"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md="2">
                                  <FormGroup className="mb15">

                                    <Label htmlFor="appointmentStartDate">
                                      {this.props.t("Date *")}
                                    </Label>
                                    <Flatpickr
                                      className={
                                        "form-control" +
                                        (errors.appointmentStartDate && touched.appointmentStartDate ? " is-invalid" : "")
                                      }
                                      value={values.appointmentStartDate}
                                      onChange={(date) => setFieldValue('appointmentStartDate', date[0])}
                                      options={{
                                        altInput: true,
                                        altFormat: "F j, Y",
                                        dateFormat: "Y-m-d",
                                        //minDate: 'today'
                                      }}
                                    />


                                    <ErrorMessage
                                      name="appointmentStartDate"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md="2">
                                  <TimePicker
                                    name="startTime"
                                    label="Start Time *"
                                    value={values.startTime}
                                    onChange={(val) => setFieldValue("startTime", val)}
                                    onBlur={() => setFieldTouched("startTime", true)}
                                    minTime={null}
                                    error={errors.startTime}
                                    touched={touched.startTime}
                                  />
                                  {errors.startTime && touched.startTime && (
                                    <div className="invalid-feedback">{errors.startTime}</div>
                                  )}
                                </Col>
                                <Col md="2">
                                  <TimePicker
                                    name="endTime"
                                    label="End Time *"
                                    value={values.endTime}
                                    onChange={(val) => setFieldValue("endTime", val)}
                                    onBlur={() => setFieldTouched("endTime", true)}
                                    minTime={values.startTime}
                                    disabled={!values.startTime}
                                    error={errors.endTime}
                                    touched={touched.endTime}
                                  />
                                </Col>



                                <Col md="2">

                                  <FormGroup className="mb-3">
                                    <Label>Select Type</Label>
                                    <div className="clearfix"></div>
                                    <div className="btn-group" role="group">
                                      <SafeField
                                        type="radio"
                                        className="btn-check"
                                        name="appointmentLocationType"
                                        id="btnradio9"
                                        value={3}
                                        checked={values.appointmentLocationType === 3}
                                        onChange={() => setFieldValue("appointmentLocationType", 3)}
                                        autoComplete="off"
                                      />
                                      <label className="btn btn-outline-secondary" htmlFor="btnradio9">
                                        In-person
                                      </label>

                                      <SafeField
                                        type="radio"
                                        className="btn-check"
                                        name="appointmentLocationType"
                                        id="btnradio10"
                                        value={1}
                                        checked={values.appointmentLocationType === 1}
                                        onChange={() => setFieldValue("appointmentLocationType", 1)}
                                        autoComplete="off"
                                      />
                                      <label className="btn btn-outline-secondary" htmlFor="btnradio10">
                                        Online
                                      </label>
                                    </div>
                                  </FormGroup>

                                </Col>

                                <Col md="9">
                                  <FormGroup className="mb-3">
                                    <Label>Location</Label>
                                    {values.appointmentLocationType === 3 ? (
                                      <PlacesAutocomplete
                                        value={values.appointmentLocation}
                                        onChange={(value) => setFieldValue('appointmentLocation', value)}
                                        onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                      >
                                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                          <div>
                                            <input
                                              {...getInputProps({
                                                placeholder: 'Enter Address...',
                                                className: 'form-control',
                                              })}
                                            />
                                            <div>
                                              {loading && <div>Loading...</div>}
                                              {suggestions.map((suggestion, i) => {
                                                const style = {
                                                  backgroundColor: suggestion.active ? '#007BFF' : '#fff',
                                                  color: suggestion.active ? '#fff' : '#000',
                                                  padding: '10px',
                                                  cursor: 'pointer'
                                                };
                                                return (
                                                  <div
                                                    key={i}
                                                    {...getSuggestionItemProps(suggestion, { style })}
                                                  >
                                                    {suggestion.description}
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        )}
                                      </PlacesAutocomplete>
                                    ) : (
                                      <SafeField
                                        name="appointmentLocation"
                                        type="text"
                                        className={
                                          "form-control" +
                                          (errors.appointmentLocation && touched.appointmentLocation ? " is-invalid" : "")
                                        }
                                        onChange={handleChange}
                                      />
                                    )}
                                    <ErrorMessage
                                      name="appointmentLocation"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>




                              <div className="clearfix">
                                
                                
                                  {hasPermission("RealtorClientAppointments", "Add") && (<SaveButton />  )} </div>
                            </Form>
                          )}
                        </Formik>
                      </CardBody>
                    </Card>
                    <Row>
                      <Col sm="12">
                        <Card className="border-full mt-4">
                          <CardBody>
                              {hasPermission("RealtorClientAppointments", "View") && (
                                <>
                            <h5 className="card-title mb20">History</h5>
                            {isResponsive ? (
                                 <DataTable
                                value={appointments}
                                dataKey="id"
                                responsiveLayout="stack"
                                expandedRows={this.state.expandedRows}
                                onRowToggle={(e) => this.setState({ expandedRows: e.data })}
                                paginator
                                rows={10}
                                rowExpansionTemplate={(rowData) => (
                                  <table className="table table-bordered mb-0">
                                    <tbody>
                                      <tr><th>Agenda</th><td>{rowData.appointmentTitle}</td></tr>
                                      <tr><th>Location Type</th><td>{rowData.appointmentLocationType === 3 ? "In-person" : rowData.appointmentLocationType === 1 ? "Online" : "—"}</td></tr>
                                      <tr><th>Location</th><td>{rowData.appointmentLocation || "—"}</td></tr>
                                      <tr>
                                        <th>Action</th>
                                        <td>
                                          <Link to="#" className="btn btn-action" onClick={() => this.toggleRightCanvas(rowData)}>Manage</Link>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                )}
                              >
   
                                <Column expander style={{ width: '3em' }} />

                              <Column
                                  header="#"
                                  body={(rowData, options) => options.rowIndex + 1}
                                  style={{ width: '60px'}}
                                />
                                <Column
                                  header="Appointment"
                                  body={(rowData) => (
                                    <div>
                                      <strong><Moment format="Do MMM YYYY">{rowData.appointmentStartDate}</Moment></strong>
                                      <div className="text-muted">{rowData.startTime} - {rowData.endTime}</div>
                                    </div>
                                  )}
                                />

                                 <Column field="lastContact" header="Action" body={(rowData) => (
                                <Link to="#" className="btn btn-action" onClick={() => this.toggleRightCanvas(rowData)}>Manage</Link>

                              )}></Column>

 
   
  </DataTable>
                            ):(
                                <DataTable className="" stripedRows value={appointments} paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries " paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown   " tableStyle={{ minWidth: '50rem' }}   >
                               <Column
                                  header="#"
                                  body={(rowData, options) => options.rowIndex + 1}
                                  style={{ width: '60px'}}
                                />
                              <Column field="lastContact" header="Date" body={(rowData) => (
                                <Moment format="Do MMMM YYYY">{rowData.appointmentStartDate}</Moment>
                              )}></Column>
                              <Column field="startTime" header="Start Time"></Column>
                              <Column field="endTime" header="End Time" ></Column>
                              <Column field="appointmentTitle" header="Agenda" ></Column>
                             <Column
                                field="appointmentLocationType"
                                header="Location Type"
                                body={(rowData) => {
                                  if (rowData.appointmentLocationType === 3) return "In-person";
                                  if (rowData.appointmentLocationType === 1) return "Online";
                                  return "—"; // fallback if undefined or another value
                                }}
                              />
                              <Column field="appointmentLocation" header="Location" ></Column>
                              {/* <Column field="lastContact" header="Accept" body={(rowData) => (
                                rowData.addedBy == 'client' ? <Switch onChange={rejected => this.handleChange(rowData)} checked={!rowData.rejected} /> : ''
                              )}></Column> */}
                              <Column field="lastContact" header="Action" body={(rowData) => (
                                <Link to="#" className="btn btn-action" onClick={() => this.toggleRightCanvas(rowData)}>Manage</Link>

                              )}></Column>
                            </DataTable>
                            )}
                           </>
                              )}


                          


                          </CardBody>
                        </Card>
                      </Col>
                    </Row>


                  </Col>

                </Row>
              </Col>

            </Row>
            <Offcanvas
              isOpen={this.state.isRight}
              direction="end"
              toggle={this.toggleRightCanvas}
              style={{ width: 600 }}
            >
              <OffcanvasHeader toggle={this.toggleRightCanvas}>
                Update
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id: appointment.id,
                    appointmentId: appointment.appointmentId,
                    appointmentTitle: appointment.appointmentTitle,
                    contactName: appointment.contactName,
                    contactPhone: appointment.contactPhone,
                    contactEmail: appointment.contactEmail,
                    appointmentStartDate: appointment.appointmentStartDate,
                    startTime: appointment.startTime,
                    endTime: appointment.endTime,
                    appointmentType: appointment.appointmentType,
                    appointmentStatus: appointment.appointmentStatus,
                    appointmentPriority: appointment.appointmentPriority,
                    appointmentReminder: appointment.appointmentReminder,
                    clientId: appointment.clientId,
                    appointmentDescription: appointment.appointmentDescription,
                    appointmentLocationType: appointment.appointmentLocationType,
                    appointmentLocation: appointment.appointmentLocation,
                    locationLatitude: appointment.locationLatitude,
                    locationLongitude: appointment.locationLongitude,
                    isRepeat: appointment.isRepeat,
                    repeatEveryType: appointment.repeatEveryType,
                    repeatStep: appointment.repeatStep,
                    repeatEndDate: appointment.repeatEndDate,
                    agentId: appointment.agentId,
                    isActive: appointment.isActive,
                    agentNotes: appointment.agentNotes,
                    addedBy: appointment.addedBy,
                    appointmentCategory: 2,
                    rejected: appointment.rejected ? '2' : '1',


                  }}


                  validationSchema={Yup.object().shape({
                    appointmentTitle: Yup.string().max(150, "150 Characters are allowed").required("Please Enter Meeting Agenda"),
                    appointmentStartDate: Yup.string().required("This is Required"),
                    startTime: Yup.string().required("This is Required"),
                    endTime: Yup.string().required("This is Required"),


                  })}

                  onSubmit={values => {
                    //
                    if (isEdit) {
                      const updateApp = {
                        id: values.id,
                        appointmentId: values.appointmentId,
                        appointmentTitle: values.appointmentTitle,
                        contactName: values.contactName,
                        contactPhone: values.contactPhone,
                        contactEmail: values.contactEmail,
                        appointmentStartDate: moment(values.appointmentStartDate).format('YYYY-MM-DD'),
                        startTime: values.startTime,
                        endTime: values.endTime,
                        appointmentType: (values.appointmentType) ? parseInt(values.appointmentType) : 0,
                        appointmentStatus: (values.appointmentStatus) ? parseInt(values.appointmentStatus) : 0,
                        appointmentPriority: (values.appointmentPriority) ? parseInt(values.appointmentPriority) : 0,
                        appointmentReminder: values.appointmentReminder,
                        clientId: values.clientId,
                        appointmentDescription: values.appointmentDescription,
                        appointmentLocationType: parseInt(values.appointmentLocationType),
                        appointmentLocation: values.appointmentLocation,
                        locationLatitude: values.locationLatitude,
                        locationLongitude: values.locationLongitude,
                        isRepeat: values.isRepeat,
                        repeatEveryType: values.repeatEveryType,
                        repeatStep: values.repeatStep,
                        repeatEndDate: values.repeatEndDate,
                        agentId: values.agentId,
                        isActive: values.isActive,
                        agentNotes: values.agentNotes,
                        addedBy: values.addedBy,
                        appointmentCategory: values.appointmentCategory,
                        rejected: (values.rejected == '2') ? false : true,
                      };
                      onUpdateClientAppointment(updateApp, (success) => {
                          if (success) {
                            this.toggle();
                          }
                        });
                      }
                   
                  }}
                >
                  {({ errors, touched, values, handleChange, handelBlur, setFieldValue, setFieldTouched }) => (
                    <Form
                      className="needs-validation"
                    >
                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="appointmentTitle">
                              {this.props.t("Agenda*")}
                            </Label>
                            <input
                              name="appointmentTitle"
                              type="text"
                              value={values.appointmentTitle}
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.appointmentTitle && touched.appointmentTitle
                                  ? " is-invalid"
                                  : "")
                              }
                              id="appAjenda"
                            />
                            <ErrorMessage
                              name="appointmentTitle"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb15">

                            <Label htmlFor="appointmentStartDate">
                              {this.props.t("Date")}
                            </Label>
                            <Flatpickr
                              className={
                                "form-control" +
                                (errors.appointmentStartDate && touched.appointmentStartDate ? " is-invalid" : "")
                              }
                              value={values.appointmentStartDate}
                              onChange={(date) => setFieldValue('appointmentStartDate', date[0])}
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                                //minDate: 'today'
                              }}
                            />



                            <ErrorMessage
                              name="appointmentStartDate"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <TimePicker
                            name="startTime"
                            label="Start Time *"
                            value={values.startTime}
                            onChange={(val) => setFieldValue("startTime", val)}
                            onBlur={() => setFieldTouched("startTime", true)}
                            minTime={null}
                            error={errors.startTime}
                            touched={touched.startTime}
                          />

                        </Col>
                        <Col md="4">
                          <TimePicker
                            name="endTime"
                            label="End Time *"
                            value={values.endTime}
                            onChange={(val) => setFieldValue("endTime", val)}
                            onBlur={() => setFieldTouched("endTime", true)}
                            minTime={values.startTime}
                            disabled={!values.startTime}
                            error={errors.endTime}
                            touched={touched.endTime}
                          />

                        </Col>


                        <Col md="12">

                          <FormGroup className="mb-3">

                            <div className="clearfix"></div>
                            <div className="btn-group" role="group">
                              <SafeField
                                type="radio"
                                className="btn-check"
                                name="appointmentLocationType"
                                id="btnradio_9"
                                value={3}
                                checked={values.appointmentLocationType === 3}
                                onChange={() => setFieldValue("appointmentLocationType", 3)}
                                autoComplete="off"
                              />
                              <label className="btn btn-outline-secondary" htmlFor="btnradio_9">
                                In-person
                              </label>

                              <SafeField
                                type="radio"
                                className="btn-check"
                                name="appointmentLocationType"
                                id="btnradio_10"
                                value={1}
                                checked={values.appointmentLocationType === 1}
                                onChange={() => setFieldValue("appointmentLocationType", 1)}
                                autoComplete="off"
                              />
                              <label className="btn btn-outline-secondary" htmlFor="btnradio_10">
                                Online
                              </label>
                            </div>
                          </FormGroup>

                        </Col>

                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label>Location</Label>
                            {values.appointmentLocationType === 3 ? (
                              <PlacesAutocomplete
                                value={values.appointmentLocation}
                                onChange={(value) => setFieldValue('appointmentLocation', value)}
                                onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                              >
                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                  <div>
                                    <input
                                      {...getInputProps({
                                        placeholder: 'Enter Address...',
                                        className: 'form-control',
                                      })}
                                    />
                                    <div>
                                      {loading && <div>Loading...</div>}
                                      {suggestions.map((suggestion, i) => {
                                        const style = {
                                          backgroundColor: suggestion.active ? '#007BFF' : '#fff',
                                          color: suggestion.active ? '#fff' : '#000',
                                          padding: '10px',
                                          cursor: 'pointer'
                                        };
                                        return (
                                          <div
                                            key={i}
                                            {...getSuggestionItemProps(suggestion, { style })}
                                          >
                                            {suggestion.description}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}
                              </PlacesAutocomplete>
                            ) : (
                              <SafeField
                                name="appointmentLocation"
                                type="text"
                                className={
                                  "form-control" +
                                  (errors.appointmentLocation && touched.appointmentLocation ? " is-invalid" : "")
                                }
                                onChange={handleChange}
                              />
                            )}
                            <ErrorMessage
                              name="appointmentLocation"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        {/* <Col sm="12">
                          <div className="btn-group" role="group">
                            <SafeField type="radio" className="btn-check" onChange={handleChange} name="rejected" id="btnradio4" value="1" autoComplete="off" />
                            <label className="btn btn-outline-secondary" htmlFor="btnradio4">Accept</label>

                            <SafeField type="radio" className="btn-check" onChange={handleChange} name="rejected" id="btnradio5" value="2" autoComplete="off" />
                            <label className="btn btn-outline-secondary" htmlFor="btnradio5">Re-schedule</label>
                          </div>
                        </Col> */}
                        <Col md="12">
                          <FormGroup className="mb15">

                            <Label htmlFor="agentNotes">
                              {this.props.t("Personal notes for the meeting")}
                            </Label>
                            <SafeField as="textarea" name="agentNotes" className="form-control" onChange={handleChange}>

                            </SafeField>

                          </FormGroup>
                        </Col>
                      </Row>




                      <div className="clearfix">
                        {hasPermission("RealtorClientAppointments", "Edit") && (
                        <UpdateButton>{this.props.t("Update")}</UpdateButton>
                        )}
                        
                        {" "} <RsLink onClick={this.toggleRightCanvas}>Close</RsLink> {" "} 
                        {hasPermission("RealtorClientAppointments", "Delete") && (
                        <RsLink className="btn-add" iconClass=" bx bx-trash-alt" onClick={() => this.onClickDelete(appointment)}>Delete Appointement</RsLink>
                        )}

                      </div>
                    </Form>
                  )}
                </Formik>
              </OffcanvasBody>
            </Offcanvas>

            <Offcanvas
              isOpen={this.state.isCal}
              direction="end"
             toggle={this.openCalender}
              style={{ width: '100%', maxWidth: 900 }}
            >
              <OffcanvasHeader toggle={this.openCalender}>
                Calendar
              </OffcanvasHeader>
              <OffcanvasBody>
                <Row className="mt-20">
                    <Col sm="12">
                      <FullCalendar
                        ref={this.calendarRef}
                        plugins={[dayGridPlugin, interactionPlugin, BootstrapTheme]}
                        initialView="dayGridMonth"
                        headerToolbar={{
                          left: "prev,next today",
                          center: "title",
                          right: "dayGridMonth,dayGridWeek,dayGridDay",
                        }}
                        editable={true}
                        droppable={true}
                        selectable={true}
                        events={resultArray}
                       
                      />

                    </Col>
                  </Row>
               </OffcanvasBody>
              </Offcanvas> 
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ClientApp.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  addClientAppointment: PropTypes.func,
  match: PropTypes.object,
  onGetClientDetail: PropTypes.func,
  clietDetail: PropTypes.object,
  appointments: PropTypes.array,
  onGetClientAppointment: PropTypes.func,
  onDeleteAppointment: PropTypes.func,
  onUpdateClientAppointment: PropTypes.func,
  loading: PropTypes.object,
  onUpdateStatus: PropTypes.func,
  userdetail: PropTypes.object,
  isResponsive:PropTypes.object

}
const mapStateToProps = ({ Clients }) => (
  {
    clietDetail: Clients.clietDetail,
    appointments: Clients.appointments,
    loading: Clients.loading

  })
const mapDispatchToProps = dispatch => ({
  addClientAppointment: (data) => dispatch(addClientAppointment(data)),
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  onGetClientAppointment: (agentId, clientId) => dispatch(getClientAppointment(agentId, clientId)),
  onDeleteAppointment: (id) => dispatch(deleteClientAppointment(id)),
  onUpdateClientAppointment: (data, callback) => dispatch(updateClientAppointment(data, callback)),
  onUpdateStatus: (data) => dispatch(updateClientAppointment(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientApp))
